angular.module('app').controller('ReportCtrl', function($http, $route, $location, $scope, ScorecardUtils, $rootScope, appUtils) {
    "ngInject";

    var main = this;
    var defaultReport = ($rootScope.is_owner || $rootScope.report_access || $rootScope.is_superadmin) ? 'dashboard_ui' : 'photographer';
    main.report = $route.current.params.report || defaultReport;
    main.editing_goals = false;

    main.setRoyaltyBeginningOfMonth = function() {
        var today = moment();
        main.start_date = today.clone().date(1).startOf('day');
        main.end_date = today.clone().date(15).endOf('day');
    };

    main.setRoyaltyEndOfMonth = function() {
        var lastMonth = moment().subtract(1, 'months');
        main.start_date = lastMonth.clone().date(16).startOf('day');
        main.end_date = lastMonth.clone().endOf('month').endOf('day');
    };

    main.setThisMonth = function() {
        var today = moment();
        main.start_date = today.clone().date(1).startOf('day');
        main.end_date = today.clone().endOf('month').endOf('day');
    };

    main.setLastMonth = function() {
        var lastMonth = moment().subtract(1, 'months');
        main.start_date = lastMonth.clone().date(1).startOf('day');
        main.end_date = lastMonth.clone().endOf('month').endOf('day');
    };

    main.getSeason = function(date) {
        if(date.month() >= 6) {
            main.start_date = date.clone().month(6).startOf('month');
            main.end_date = date.clone().endOf('year');
        } else {
            main.start_date = date.clone().startOf('year');
            main.end_date = date.clone().month(5).endOf('month');
        }
    };

    main.setThisSeason = function() {
        var today = moment();
        return main.getSeason(today);
    };

    main.setLastSeason = function() {
        var lastSeason = moment().subtract(6, 'months');
        return main.getSeason(lastSeason);
    };
    
    main.setThisYear = function() {
        var today = moment();
        main.start_date = today.clone().startOf('year').startOf('day');
        main.end_date = today.clone().endOf('year').endOf('day');
    };
    
    main.setLastYear = function() {
        var lastYear = moment().subtract(1, 'year');
        main.start_date = lastYear.clone().startOf('year').startOf('day');
        main.end_date = lastYear.clone().endOf('year').endOf('day');
    };

    var end = moment().year()
    main.goalYear = end;
    main.years = [];
    for(var start = 2019; start <= end; start++) {
        main.years.push(start);
    }

    main.updateDate = function() {
        if(main.dateRange == 'first') {
            main.setRoyaltyBeginningOfMonth();
        } else if (main.dateRange == 'last') {
            main.setRoyaltyEndOfMonth();
        } else if (main.dateRange == 'thisSeason') {
            main.setThisSeason();
        } else if (main.dateRange == 'lastSeason') {
            main.setLastSeason();
        } else if (main.dateRange == 'thisMonth') {
            main.setThisMonth();
        } else if (main.dateRange == 'lastMonth') {
            main.setLastMonth();
        } else if (main.dateRange == 'thisYear') {
            main.setThisYear();
        } else if (main.dateRange == 'lastYear') {
            main.setLastYear();
        }

        main.refreshReport();
    };

    main.pick = function(key, rows) {
        return rows.map(function(row) {
            return row[key];
        });
    };

    main.mapColors = function(rows) {
        var colors = [
            '#97BBCD', // blue
            '#DCDCDC', // light grey
            '#F7464A', // red
            '#46BFBD', // green
            '#FDB45C', // yellow
            '#949FB1', // grey
            '#4D5360'  // dark grey
        ];
        colorLen = colors.length;

        return rows.map(function(row, index) {
            return colors[index % colorLen];
        });
    };

    main.formatDate = function(date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    };

    main.royalty = function() {
        main.basicReport(
            '/api/v1/admin/report/royalty',
            'Sales',
            'name',
            'raw_sales'
        );
    };
    
    // Initialize routing data properties
    main.routingData = [];
    main.routingFileLoaded = false;
    
    // Function to handle the routing file upload
    main.handleRoutingFile = function(file) {
        if (!file) {
            return;
        }
        
        var reader = new FileReader();
        reader.onload = function(e) {
            var contents = e.target.result;
            
            // Parse CSV data
            var rows = contents.split('\n');
            var headerRow = rows[0].split(',');
            
            // Find the indexes of required columns
            var idIndex = headerRow.findIndex(col => col.trim().toLowerCase() === 'id');
            var routingIndex = headerRow.findIndex(col => col.trim().toLowerCase() === 'routing #' || 
                                                        col.trim().toLowerCase() === 'routing#');
            var accountIndex = headerRow.findIndex(col => col.trim().toLowerCase() === 'account #' || 
                                                         col.trim().toLowerCase() === 'account#');
            
            if (idIndex === -1 || routingIndex === -1 || accountIndex === -1) {
                alert('CSV must contain columns: Id, Routing #, and Account #');
                return;
            }
            
            // Process data rows
            main.routingData = [];
            for (var i = 1; i < rows.length; i++) {
                if (!rows[i].trim()) continue; // Skip empty rows
                
                var cells = rows[i].split(',');
                if (cells.length <= Math.max(idIndex, routingIndex, accountIndex)) continue;
                
                main.routingData.push({
                    id: cells[idIndex].trim(),
                    routing: cells[routingIndex].trim(),
                    account: cells[accountIndex].trim()
                });
            }
            
            main.routingFileLoaded = true;
            // Trigger digest cycle since this is called from onchange
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };
        
        reader.readAsText(file);
    };
    
    // Helper function for generating CSV data
    main.generateCSV = function(item_name) {
        if (main.report !== 'royalty' || !main.data || !main.data.rows) {
            return;
        }
        
        // Different headers for royalty vs tech fee reports
        var headers, nameField, amountField,filename;
        var isTechFee = (item_name === 'Tech Fee');
        
        if (isTechFee) {
            headers = main.routingFileLoaded ? 
                "ID,Customer,Amount,Item,Type,Routing #,Account #,,Customer,,Item,,Description,Number,,Amount\n" : 
                "ID,Customer,Amount,Item,Type,,Customer,,Item,,Description,Number,,Amount\n";
            nameField = 'quickbooks_tech_name';
            amountField = 'raw_tech_fee';
            filename = 'tech_fee_report.csv';
        } else {
            nameField = 'quickbooks_royalty_name';
            headers = main.routingFileLoaded ? 
                "ID,Customer,Amount,Item,Type,Routing #,Account #,,Customer,Sales,Item,,Description,Number,Royalty Rate\n" : 
                "ID,Customer,Amount,Item,Type,,Customer,Sales,Item,,Description,Number,Royalty Rate\n";
            amountField = 'raw_royalty';
            filename = 'royalty_report.csv';
        }
        
        // Prepare CSV content
        var csvContent = headers;
        
        main.data.rows.forEach(function(row) {
            var customerName = row[nameField] || row.name;
            var amount = row[amountField];
            var sales = row.raw_sales || 0;

            if(amount == 0) {
                return true;
            }
            
            // Different data for royalty vs tech fee
            var rateValue;
            if (isTechFee) {
                rateValue = row.tech_percentage_fee || 0; // Tech Fee percentage
            } else {
                rateValue = row.royalty_percentage ? parseFloat(row.royalty_percentage) / 100 : 0; // Royalty rate
            }
            
            // Create an array for the CSV row
            var csvRow = [
                row.id,
                '"' + customerName.replace(/"/g, '""') + '"', // Escape quotes in customer name
                amount,
                item_name,
                'checking'
            ];
            
            // Add routing info if available
            if (main.routingFileLoaded) {
                // Find matching routing data by ID
                var routingInfo = main.routingData.find(function(r) {
                    return r.id == row.id; // Use loose equality to match string and number IDs
                });
                
                if (routingInfo) {
                    csvRow.push(routingInfo.routing);
                    csvRow.push(routingInfo.account);
                } else {
                    csvRow.push('');
                    csvRow.push('');
                }
            }
            
            // Add the duplicate columns with additional data
            csvRow.push(''); // Empty column as separator
            csvRow.push('"' + customerName.replace(/"/g, '""') + '"'); // Duplicate customer name
            
            if (isTechFee) {
                csvRow.push(''); // Empty column as separator
                csvRow.push(item_name); // Empty column as separator
                csvRow.push(''); // Empty column as separator
                csvRow.push('Monthly Tech Fee'); // Empty column as separator
                csvRow.push('EZGo'); // Empty column as separator
                csvRow.push(''); // Empty column as separator
                csvRow.push(row.min_tech_fee); // Tech Fee amount
            } else {
                csvRow.push(sales); // Sales amount
                csvRow.push(item_name); // Duplicate item name
                csvRow.push(''); // Empty column as separator
                csvRow.push('Royalties'); // Empty column as separator
                csvRow.push(''); // Empty column as separator
                csvRow.push(rateValue); // Royalty rate
            }
            
            csvContent += csvRow.join(',') + "\n";
        });
        
        // Use appUtils to download the file
        appUtils.fileReaderDownload('text/csv;charset=utf-8;', filename, csvContent);
    };
    
    // Function for royalty CSV download
    main.downloadRoyaltyCSV = function() {
        main.generateCSV('Royalty');
    };
    
    // Function for tech fee CSV download
    main.downloadTechCSV = function() {
        main.generateCSV('Tech Fee');
    };

    main.salesSchool = function() {

        if(!main.school) {
            main.showDatePicker = false;
            main.template = 'salesSchool.html';
            main.chart = false;
            main.data = {};
            return;
        }
        params = {
            'start_date': main.formatDate(main.start_date),
            'end_date': main.formatDate(main.end_date),
            'school_id': main.school.id
        };

        main.basicReport(
            '/api/v1/admin/report/school',
            'Sales',
            'event_name',
            'raw_sales',
            params
        );

        main.showDatePicker = false;
        main.template = 'salesSchool.html';
    };

    main.territory = function() {
        main.showDatePicker = true;
        main.template = 'territory-details.html';
        main.chart = false;

        var params = {
            'start_date': main.formatDate(main.start_date),
            'end_date': main.formatDate(main.end_date),
            'franchise_id': $location.search().franchise_id,
            'territory_id': $location.search().territory_id,
        };

        main.loadBasicReport('/api/v1/admin/report/territory', params).then(
            function(response) {
                main.loading = false;
                main.data = response.data;
            }
        );
    }

    main.load_super_admin_table = function() {
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-super-admin',
        }).then(
            function(response) {
                main.loading = false;
                main.superAdmin = response.data;
                main.load_ytd();
            }
        );
    }

    main.dashboard_ui = function() {
        main.data = false;
        main.chart = false;
        main.showDatePicker = false;
        main.template = 'dashboard_ui.html';

        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-new',
            'params': {'year': main.goalYear }
        }).then(
            function(response) {
                main.loading = false;
                main.thisYear = main.goalYear
                main.lastYear = main.thisYear - 1
                main.sales = response.data.sales
                main.forecast = response.data.forecast;
                main.goals = response.data.goals;
                main.kids_needed = [];

                ScorecardUtils.refresh_scorecard_goals(main);

                if($rootScope.is_superadmin) {
                    main.load_super_admin_table();
                } else {
                    main.load_ytd();
                }
            }
        );
    };

    main.salesEvent = function() {

        main.showDatePicker = true;
        main.template = false;

        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/sales/by-event',
            'params': {
                'start_date': main.formatDate(main.start_date),
                'end_date': main.formatDate(main.end_date)
            }
        }).then(
            function(response) {
                main.loading = false;
                main.data = response.data;
                main.chart = main.buildChart(
                    'Sales',
                    main.data.chart_data.labels,
                    main.data.chart_data.data
                );
            }
        );
    };

    main.photographer = function() {

        main.showDatePicker = true;
        main.template = false;

        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/photographer',
            'params': {
                'start_date': main.formatDate(main.start_date),
                'end_date': main.formatDate(main.end_date)
            }
        }).then(
            function(response) {
                main.loading = false;
                main.data = response.data;
                var totals = main.data.rows.filter((row) => {
                    return row.event_name == null;
                });
                var users = main.pick('user_name', totals);

                main.chart = main.buildChart(
                    'Sales',
                    users, 
                    main.pick('raw_sales', totals)
                );
            }
        );
    };

    main.salesByDate = function() {
        main.showDatePicker = true;
        main.template = false;

        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/sales',
            'params': {
                'start_date': main.formatDate(main.start_date),
                'end_date': main.formatDate(main.end_date)
            }
        }).then(
            function(response) {
                main.loading = false;
                main.data = response.data;
                var rows = main.data.rows.filter(function(r) {
                    return r.class != 'total';
                });
                main.chart =  {
                    'type': 'line',
                    'options': {
                        scales: {
                            'yAxes': [
                                {'type': 'linear', 'position': 'left', 'id': 'y1'},
                                {'type': 'linear', 'position': 'right', 'id': 'y2'},
                            ],
                            xAxes: [{type: 'time'}]
                        }
                    },
                    'data': {
                        'labels': main.pick('date', rows),
                        'datasets': [
                            {
                                'label': '# of Orders',
                                'backgroundColor': 'rgba(151, 187, 205, 0.8)',
                                'borderColor': 'rgba(151, 187, 205, 0.4)',
                                'fill': false,
                                'data': main.pick('count', rows),
                                'yAxisID': 'y1', 
                            },
                            {
                                'label': 'Sales',
                                'backgroundColor': 'rgba(240, 70, 74, 0.8)',
                                'borderColor': 'rgba(240, 70, 74, 0.4)',
                                'fill': false,
                                'data': main.pick('raw_total', rows),
                                'yAxisID': 'y2', 
                            },
                        ]

                    }
                };
            }
        );
    };

    main.load_ytd = function() {
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-ytd',
            'params': {'year': main.goalYear }
        }).then(function(response) {
            main.loading = false;
            main.ytd_needed = 0;
            var chart = angular.copy(ScorecardUtils.chart);
            chart.data.labels = ['Totals'];
            chart.data.datasets[4].type = 'bar';
            delete chart.data.datasets[4].datalabels;

            var data = response.data;
            var activeFranchiseId = $rootScope.franchiseSwitcher.activeFranchise();

            main.sales_ytd = 0;
            try {
                main.sales_ytd = data.sales_ytd.find((row) => { return row.id == activeFranchiseId }).total;
            } catch(e) {
            }
            chart.data.datasets[1].data = [main.sales_ytd];
            ScorecardUtils.update_goal_total(main);
            chart.data.datasets[0].data = [main.ytd_needed];
            chart.options.scales['y1'].suggestedMax = main.ytd_needed * 1.5;

            var sales_last_year_ytd = 0;
            try {
                sales_last_year_ytd = data.sales_last_year_ytd.find((row) => { return row.id == activeFranchiseId }).total;
            } catch(e) {
            }

            // Calculate forecast YTD
            var forecast_ytd = 0;
            if (main.forecast) {
                var month = new Date().getMonth();
                var months = ['january', 'february', 'march', 'april', 'may', 'june',
                              'july', 'august', 'september', 'october', 'november', 'december'];
                for (var i = 0; i <= month; i++) {
                    var key = months[i] + ' ' + main.thisYear;
                    if (main.forecast[key]) {
                        forecast_ytd += main.forecast[key];
                    }
                }
            }
            chart.data.datasets[2].data = [forecast_ytd];
            chart.data.datasets[3].data = [sales_last_year_ytd];
            chart.data.datasets[4].data = [main.goalYtd];
            main.ytd = chart;

            // Helper function to create franchise revenue chart
            var createFranchiseChart = function(franchises, title) {
                return {
                    'type': 'bar',
                    'data': {
                        'labels': main.pick('name', franchises),
                        'datasets': [
                            {
                                'label': 'Sales (This Year)',
                                'backgroundColor': '#9900ff',
                                'data': main.pick('total', franchises)
                            },
                            {
                                'label': 'Sales (Last Year)',
                                'backgroundColor': '#ffd967',
                                'data': franchises.map(function(franchise) {
                                    var lastYearData = data.sales_last_year_ytd.find(function(f) {
                                        return f.id === franchise.id;
                                    });
                                    return lastYearData ? lastYearData.total : 0;
                                })
                            }
                        ]
                    },
                    'options': {
                        'title': {
                            'display': true,
                            'text': title
                        }
                    }
                };
            };
            
            // Split franchises based on current year revenue threshold of $250,000
            var highRevenueFranchises = [];
            var lowRevenueFranchises = [];
            
            data.sales_ytd.forEach(function(franchise) {
                if (franchise.total >= 250000) {
                    highRevenueFranchises.push(franchise);
                } else {
                    lowRevenueFranchises.push(franchise);
                }
            });
            
            // Create charts based on franchise revenue split
            main.ytd_high_revenue_franchises = highRevenueFranchises.length > 0 
                ? createFranchiseChart(highRevenueFranchises, 'Franchises with Revenue ≥ $250,000')
                : null;
                
            main.ytd_low_revenue_franchises = lowRevenueFranchises.length > 0
                ? createFranchiseChart(lowRevenueFranchises, 'Franchises with Revenue < $250,000')
                : null;

            main.load_franchise_stats();
        });
    };

    main.scorecard = ScorecardUtils.chart;
    main.scorecardUtils = ScorecardUtils;

    main.load_session_stats = function() {
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-session-stats',
            'params': {'year': main.goalYear},
        }).then(function(response) {
            main.session_stats = response.data;
            main.loading = false;
            main.load_sales_by_product();
        })
    };

    main.load_franchise_stats = function(loadNext) {
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-franchise-stats',
            'params': {
                'year': main.goalYear,
                'exclude_class_portrait': !!main.exclude_class_portrait,
            },
        }).then(function(response) {
            main.franchise_stats = response.data;
            main.loading = false;
            if(loadNext !== false) {
                main.load_session_stats();
            }
        })
    };

    main.load_sales_by_product = function() {
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/report/dashboard-sales-by-product',
        }).then(function(response) {
            main.sales_by_product = response.data;
            main.loading = false;

        })
    };

    $scope.$watch('main.goals', function() { ScorecardUtils.update_goal_total(main) });

    main.buildChart = function(label, labels, rows) {
        return {
            'type': 'bar',
            'data': {
                'labels': labels,
                'datasets': [{
                    'label': label,
                    'backgroundColor': main.mapColors(rows),
                    'data': rows
                }]
            }
        };
    };

    main.loadBasicReport = function(url, params) {
        if(!params) {
            params = {
                'start_date': main.formatDate(main.start_date),
                'end_date': main.formatDate(main.end_date)
            };
        }
        main.loading = $http({
            'method': 'GET',
            'url':url,
            'params': params
        });
        return main.loading;
    };

    main.basicReport = function(url, label, label_key, data_key, params) {

        main.showDatePicker = true;
        main.template = false;

        main.loadBasicReport(url, params).then(
            function(response) {
                main.loading = false;
                main.data = response.data;
                var rows = main.data.rows;
                if(label_key && data_key) {
                    var labels = main.pick(label_key, rows);
                    var chartRows = main.pick(data_key, rows);
                    main.chart = main.buildChart(label, labels, chartRows); 
                } else {
                    main.chart = false;
                }
            }
        );
    };

    main.salesTax = function() {
        main.basicReport(
            '/api/v1/admin/report/sales-tax',
            'Due',
            'name',
            'raw_due'
        );
    };

    main.topSchools = function() { main.basicReport('/api/v1/admin/report/top-schools'); };
    main.topCustomers = function() { main.basicReport('/api/v1/admin/report/top-customers'); };

    main.profitLoss = function() {
        main.showDatePicker = true;
        main.template = false;

        main.loadBasicReport('/api/v1/admin/report/profit-loss').then(
            function(response) {
                main.loading = false;
                main.data = response.data;
                labels = ['Gross Profit', 'Expenses', 'Net Profit'];
                main.chart = main.buildChart('Profit and Loss', ['Gross', 'Expenses', 'Net'], main.data.chart);
            }
        );
    };

    main.refreshReport = function() {
        main[main.report]();
    };

    main.goalsOverview = function() {
        main.showDatePicker = false;
        main.template = 'goals-overview.html';
        main.scorecards = [{'title': 'All Franchises'}];

        main.thisYear = main.goalYear
        main.lastYear = main.thisYear - 1

        var populateScorecard = function(response, franchise, isOverview) {
            var payload = response.data;
            payload.scorecard = angular.copy(ScorecardUtils.chart);
            payload.thisYear = main.thisYear;
            payload.lastYear = main.lastYear;
            payload.kids_needed = [];
            payload.ytd = false;
            payload.forecast = response.data.forecast;
            ScorecardUtils.update_goal_total(payload);
            if(isOverview !== true) {
                payload.title = franchise.name;
                main.scorecards.push(payload);
            } else {
                payload.title = 'All Franchises';
                main.scorecards[0] = payload;
            }
        };

        var load_next_franchise = function(franchises, index) {
            if(index > franchises.length) {
                return;
            }
            var franchise = franchises[index];
            $http.get(
                '/api/v1/admin/report/dashboard-new',
                {'params': {'franchise_id': franchise.id, 'year': main.goalYear}}
            ).then((response) => {
                populateScorecard(response, franchise, false);
                load_next_franchise(franchises, index+1);
            });
        };

        $http.get(
            '/api/v1/admin/report/dashboard-new',
            {'params': {'franchise_id': false, 'year': main.goalYear}}
        ).then((response) => populateScorecard(response, null, true));

        franchises = $http.get('/api/v1/admin/franchise?results_per_page=1000&order=id&q={"filters":[{"name":"id","op":"neq","val":2}]}').then(
            function(response) {
                load_next_franchise(response.data.objects, 0);
            }
        );
    };

    main.changeReport = function() {
        $location.search('report', main.report);
        if(main.report != 'royalty' && (main.dateRange == 'first' || main.dateRange == 'last')) {
            main.dateRange = 'custom';
        }
    };

    $scope.$on('$routeUpdate', function() {
        main.report = $location.search().report || defaultReport;
        main[main.report]();
    });

    var today = moment();
    if(main.report == 'royalty') {
        if(today.date() < 16) {
            main.dateRange = 'last';
        } else {
            main.dateRange = 'first';
        }
    } else {
        main.dateRange = 'thisMonth';
    }
    main.updateDate();
});
